export default __webpack_public_path__ + "static/media/bus-light.9f681c66.svg";